import * as React from 'react';
import { Badge, Tabs, Icon } from 'antd';

import { UserTaskSummariesDataService } from 'src/app/general/user-tasks/list/user-task-list.data';
import { AddUserTaskView } from 'src/app/general/user-tasks/parts/add-user-tasks.view';
import { container } from 'src/inversify.config';
import { ContextService } from 'src/core/services/context.service';
import { FormatService } from 'src/core/services/format.service';

const TabPane = Tabs.TabPane;

export default class UserTaskTab {

	component: React.Component<any, { userTaskCount: number }>;
	modelId: any;
	modelType: string;
	setBusy: (e) => void;
	daedline: Date;
	assignedToId: number;
	priority: number;
	titleTask: string;
	userTaskDataService: UserTaskSummariesDataService;

	constructor(component: React.Component<any, { userTaskCount: number }>, modelId: any, modelType: string, setBusy: (e) => void,
		daedline: Date,
		assignedToId: number,
		priority: number,
		titleTask: string,
	) {
		this.modelId = modelId;
		this.modelType = modelType;
		this.setBusy = setBusy;
		this.daedline = daedline;
		this.assignedToId = assignedToId;
		this.titleTask = titleTask;
		this.priority = priority;
		this.component = component;

		this.init();
	}

	private init = async () => {
		var contextService = container.get(ContextService);
		var formatService = container.get(FormatService);

		this.userTaskDataService = UserTaskSummariesDataService.make(contextService, formatService);

		this.userTaskDataService.addSorting('priority', 'asc', true);
		this.userTaskDataService.addFilter('isDeleted', 'eq', false);

		this.userTaskDataService.addFilter('modelType', 'eq', this.modelType)
		this.userTaskDataService.addFilter('modelId', 'eq', this.modelId)
		this.userTaskDataService.params = {};
		this.userTaskDataService.params["useLoginFilter"] = true;
		let items = await this.userTaskDataService.load(query => query)
		this.component.setState({ userTaskCount: items.length });
	}

	public render() {
		return (
			<TabPane key='user-tasks' tab={<Badge style={{ right: '-15px', marginTop: '10px' }} count={this.component.state.userTaskCount}><span><Icon type="check-square-o" /> User tasks</span></Badge>}>
			<AddUserTaskView
				onLoad={data => { this.component.setState({ userTaskCount: data.length }) }}
				useLoginFilter={true}
				modelId={this.modelId}
				modelType={this.modelType}
				setBusy={this.setBusy}
				daedline={this.daedline}
				assignedToId={this.assignedToId}
				priority={this.priority}
				titleTask={this.titleTask}
			/>
			</TabPane>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/user-tasks/parts/user-tasks-tab.view.tsx